"use client";
import React, { useContext, useEffect, useState } from "react";
import "../../Inventory Management System/Styles/spreadsheet.css";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import { useNavigate, useParams } from "react-router-dom";

import Select from "react-select";
import { AppContext } from "../../../context/AppContext";
// import ApiConfig from "../../../api/ApiConfig";
import { putMultipartWithAuthCall, putWithAuthCall, simpleGetCall } from "../../../api/ApiServices";
import { notifySuccess } from "../../../toaster/notify";

export default function Editcategory() {
  const { parentCategory, selectedStoreID,sidebar,ApiConfig} = useContext(AppContext)
  const naviget = useNavigate()
  const id = useParams()
  const [schedules, setSchedules] = useState([]);
  const [categoryId, setCategoryId] = useState([])
  const [categoryList, setCategoryList] = useState([])
  const [parentCategoryId, setParentCategoryId] = useState({})

  const [everyDayChecked, setEveryDayChecked] = useState(false);
  const [checkDays, setCheckDays] = useState(false)
  const [showScheduleForm, setShowScheduleForm] = useState(false);
  const [updateCategory, setupdateCategory] = useState({
    category_name: "",
    category_timing: [
      {
        schedule_name: "",
        schedule_day: [],
        schedule_time_slots: [
          {
            start_time: "",
            end_time: ""
          }
        ]
      }
    ],
    category_image: "",
    category_rank: "0",
    active: "1"

  })



  const [errors, setErrors] = useState({
    category_name: '',
    schedule_name: '',
    schedule_day: '',
    start_time: '',
    end_time: '',
    category_image: ""


  });

  console.log("Addd Category Data>>>>", updateCategory)
  console.log("checkDays Category days>>>>", checkDays)

  console.log("EditeCategory id>>>>", id?.id)


  const handleAddSchedule = () => {
    setShowScheduleForm(true);
  };



  const handleCategoryID = (select) => {

    setCategoryId(select)

  }


  const handleTimeChange = (e, timeSlotIndex, timeType) => {
    const updatedTime = e.target.value;

    setupdateCategory({
      ...updateCategory,
      category_timing: updateCategory.category_timing.map((item, index) => {
        if (index === 0) {
          return {
            ...item,
            schedule_time_slots: item.schedule_time_slots.map((timeSlot, slotIndex) => {
              if (slotIndex === timeSlotIndex) {
                if (timeType === 'start_time') {
                  return { ...timeSlot, start_time: updatedTime };
                } else if (timeType === 'end_time') {
                  return { ...timeSlot, end_time: updatedTime };
                }
              }
              return timeSlot;
            }),
          };
        }
        return item;
      }),
    });
  };



  const handleClearAddData = () => {
    setupdateCategory({
      ...updateCategory,
      category_name: "",
      category_timing: [
        {
          schedule_name: "",
          schedule_day: "",
          schedule_time_slots: [
            {
              start_time: "",
              end_time: ""
            }
          ]
        }
      ],
      category_image: ""

    })
  }

  const getCategoryList = (id) => {
    simpleGetCall(ApiConfig?.GET_CATEGORY_LIST + `parent_category_id=${id?.parent_category_id }&shop_id=${selectedStoreID}`
    )
      .then((res) => {
        console.log("Category List>>>>>", res.data)
        const categotyResponse = res?.data.map((store) => ({
          value: store.id,
          label: store.category_name,
        }));
        setCategoryList(categotyResponse)

      })
      .catch((err) => {
        console.log("Category err>>>>>", err)

      })
  }


  const onupdateCategoryData = () => {
    let validation = false;
    const newErrors = { ...errors };

    // Check each field and set errors
    if (!updateCategory.category_name) {
      validation = true;
      newErrors.category_name = 'Category name is required';
    } else {
      newErrors.category_name = '';
    }

    if (!updateCategory.category_image) {
      validation = true;
      newErrors.category_image = 'Image file  required';
    } else {
      newErrors.category_image = '';
    }

    if (!updateCategory.category_timing[0]?.schedule_name) {
      validation = true;
      newErrors.schedule_name = 'Schedule name is required';
    } else {
      newErrors.schedule_name = '';
    }

    if (!updateCategory.category_timing[0]?.schedule_day?.length) {
      validation = true;
      newErrors.schedule_day = 'At least one day must be selected';
    } else {
      newErrors.schedule_day = '';
    }

    if (!updateCategory.category_timing[0]?.schedule_time_slots[0]?.start_time) {
      validation = true;
      newErrors.start_time = 'Start time is required';
    } else {
      newErrors.start_time = '';
    }

    if (!updateCategory.category_timing[0]?.schedule_time_slots[0]?.end_time) {
      validation = true;
      newErrors.end_time = 'End time is required';
    } else {
      newErrors.end_time = '';
    }

    setErrors(newErrors);
    // if (!validation) {

      let formData = new FormData()
      formData.append('category_name', updateCategory.category_name)
      formData.append('category_rank', 0)
      formData.append('category_timing', updateCategory.category_timing)
      formData.append('status', updateCategory?.active)
      formData.append('shop_id', selectedStoreID)
      formData.append('category_image', updateCategory.category_image)
      const addCategoryById = categoryId.map((item) => item.value);

      if (parentCategory === true) {
        // Instead of appending as a single string, append each item individually
        addCategoryById.forEach((category, index) => {
          formData.append(`category_ids[${index}]`, category); // Append as an array by using '[]' in the key
        });
      }

      const CatedoryId = id?.id
      const url = parentCategory === true ? ApiConfig?.UPDATE_PARENT_CATEGORY : ApiConfig.ADD_CATEGORY
      putMultipartWithAuthCall(`${url}/${CatedoryId}`, formData)
        .then((res) => {
          console.log(res)
          if (res.success === true) {
            naviget("/BaseMenu")
                      notifySuccess(res?.message);
            
            handleClearAddData()

          }
        })
        .catch((err) => {
          console.log(err)
        })

    // }


  }


  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setupdateCategory({
        ...updateCategory,
        category_image: selectedFile
      });
    }
  };

  useEffect(() => {
    fetchCategoryDetails()
  }, [])

  useEffect(() => {
    console.log("updateCategory has changed", updateCategory);
  }, [updateCategory]);

  const fetchCategoryDetails = async () => {
    // setLoading(true)
    const url = parentCategory === true ? ApiConfig?.DETAILS_PARENT_CATEGORY : ApiConfig?.ADD_CATEGORY
    try {
      const response = await simpleGetCall(`${url}/${id?.id}`);
      if (response.success === true) {
        // setLoading(false)
        let category = response?.data
        const timing = parentCategory === true ? category?.timing : category?.category_timing
        const parsedCategoryTiming = JSON.parse(timing || "[]");
// ✅ show form only when timing exists and is not empty
if (Array.isArray(parsedCategoryTiming) && parsedCategoryTiming.length > 0) {
  setShowScheduleForm(true);
} else {
  setShowScheduleForm(false);
}
        // Set the state with the updated values
        if (parentCategory === true) {
          setupdateCategory({
            ...updateCategory,
            category_name: category?.name,
            category_timing: parsedCategoryTiming.map(timing => ({
              schedule_name: timing?.schedule_name || "",
              schedule_day: timing?.schedule_day || "[]",
              schedule_time_slots: timing?.schedule_time_slots.map(slot => ({
                start_time: slot?.start_time || "",
                end_time: slot?.end_time || ""
              })) || " []"
            })),
            category_image: category?.image_url || "",
            category_rank: category?.rank,
            active: category?.status === true ? "1" : "0"

          });
          const PrentCateGoryList = category.categories.map((item) => ({
            value: item.id,
            label: item.category_name,
          }))
          setParentCategoryId(category?.categories[0])
          setCategoryId(PrentCateGoryList)
        } else {
          setupdateCategory({
            ...updateCategory,
            category_name: category?.category_name,
            category_timing: parsedCategoryTiming.map(timing => ({
              schedule_name: timing?.schedule_name || "",
              schedule_day: timing?.schedule_day || "[]",
              schedule_time_slots: timing?.schedule_time_slots.map(slot => ({
                start_time: slot?.start_time || "",
                end_time: slot?.end_time || ""
              })) || " []"
            })),
            category_image: category?.category_image_url || "",
            category_rank: category?.category_rank,
            active: category?.active
          });
        }
    


        // SetCategoryList(category)
      } else {
        console.log("Dropdown API Error:");
      }
    } catch (err) {
      console.log("Dropdown API Error:", err);
    }
  };



 

  const handleCancel = () => {
    naviget("/BaseMenu")
    handleClearAddData()


  };

  useEffect(() => {
    if(parentCategoryId){
    getCategoryList(parentCategoryId)
  }
  }, [parentCategoryId])

  return (
    <div
        className={sidebar ? "taskMain " : "cx-active taskMain"}
        id="cx-main"
      >
        <div className="role-content">
        <div className="sub-header-role ">
            <h6 className="mt-2">Menu List</h6>
          </div>
    <div className="p-3">

      <div className="w-full bg-white p-4 border border-gray-300">
        <div className="row g-3">
          <div className="col-md-4">
            <label className="form-label cat-lab">Name</label>
            <input
              className="form-control me-2 flex-grow-1"
              type="text"
              placeholder="Enter name"
              value={updateCategory?.category_name}
              onChange={(e) => setupdateCategory(
                {
                  ...updateCategory,
                  category_name: e.target.value
                }
              )}
            />
            {errors.category_name && (
              <div className="text-danger mt-1">{errors.category_name}</div>
            )}
          </div>

          {
            parentCategory === true ?
              <div className="col-md-4">
                <label className="form-label cat-lab">Category</label>
                <Select
                  options={categoryList}
                  onChange={handleCategoryID}
                  placeholder="Select Category"
                  value={categoryId}
                  isMulti
                />
              </div>

              : ""
          }

          <div className="col-md-4">
            <label className="form-label cat-lab">Image</label>
            <div className="input-group">
              <input
                type="file"
                className="form-control"
                id="customFile"
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
              <div id="fileName" className="mt-1 ms-2 flex-1">
                {updateCategory?.category_image?.name ? 
                updateCategory?.category_image?.name : 
                updateCategory?.category_image.substring(updateCategory?.category_image.indexOf("uploads/"))|| "No file selected"}
              </div>
              <label
                className="input-group-text btn "style={{backgroundColor:"#53B7E8", color:"#fff"}}
                htmlFor="customFile"
              >
                Choose File
              </label>
            </div>
            <label className="tax-lab text-head text-muted small">
              Upload only png, jpeg, or jpg file
            </label>
            {errors.category_image && (
              <div className="text-danger mt-1">{errors.category_image}</div>
            )}
          </div>
        </div>
      </div>

      <div className="w-full bg-white p-4 border mt-3">
        {/* Header with Add Schedule Button */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <label className="edit-cat">Category Schedule</label>
          <button type="button" className="btn " style={{backgroundColor:"#53B7E8", color:"#fff"}} onClick={handleAddSchedule}>
            Add Schedule
          </button>
        </div>

        {/* Show Schedule Form when Add Schedule is clicked */}
        {showScheduleForm && (
          <div className="row pb-3">
            <div className="col">
              <label className="form-label cat-lab">
                Name<span style={{ color: "red" }}>*</span>
              </label>
              <input
                className="form-control mb-2"
                type="text"
                placeholder="Enter name"
                value={updateCategory?.category_timing[0]?.schedule_name}
                onChange={(e) => setupdateCategory({
                  ...updateCategory,
                  category_timing: updateCategory.category_timing.map((item, index) =>
                    index === 0 ? { ...item, schedule_name: e.target.value } : item
                  )
                })}
              />
              {errors.schedule_name && (
                <div className="text-danger mt-1">{errors.schedule_name}</div>
              )}

              {/* Conditionally show individual checkboxes */}
              {!everyDayChecked && (
                <div className="d-flex flex-wrap gap-2">
                  {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day) => (
                    <div className="form-check" key={day}>
                      <input
                        type="checkbox"
                        checked={updateCategory?.category_timing[0]?.schedule_day.includes(day)}  // Check if the day is in the selected days array
                        onChange={(e) => {
                          const isChecked = e.target.checked;
                          let currentScheduleDay = updateCategory.category_timing[0]?.schedule_day;

                          if (!Array.isArray(currentScheduleDay)) {
                            currentScheduleDay = [];
                          }

                          const updatedScheduleDay = isChecked
                            ? [...currentScheduleDay, day] // Add day if checked
                            : currentScheduleDay.filter(d => d !== day); // Remove day if unchecked

                          setupdateCategory({
                            ...updateCategory,
                            category_timing: updateCategory.category_timing.map((item, index) =>
                              index === 0 ? { ...item, schedule_day: updatedScheduleDay } : item
                            )
                          });
                        }}
                        id={day.toLowerCase()}
                      />
                      <label className="form-check-label" htmlFor={day.toLowerCase()}>
                        {day}
                      </label>
                    </div>
                  ))}
                </div>

              )}
              {errors.schedule_day && (
                <div className="text-danger mt-1"><label className="sm">{errors.schedule_day}</label></div>
              )}
            </div>

            <div className="col">
              <label className="form-check-label " style={{ marginLeft: "20px" }}>
                Day<span style={{ color: "red" }}>*</span>
              </label>
              <div className="form-check">
                <input
                  type="checkbox"
                  id="everyDay"
                  onChange={(e) => {
                    setEveryDayChecked(!everyDayChecked)
                    const isChecked = e.target.checked;

                    // If "Every Day" is selected, set all days; otherwise, clear it
                    const updatedScheduleDay = isChecked ? ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].join(",") : "";

                    setupdateCategory({
                      ...updateCategory,
                      category_timing: updateCategory?.category_timing.map((item, index) =>
                        index === 0 ? { ...item, schedule_day: updatedScheduleDay } : item
                      )
                    });
                  }}
                />
                <label className="form-check-label" htmlFor="everyDay">
                  Every Day
                </label>
              </div>
            </div>

            <div className="row g-3 mb-4">
              <div className="col-md-3">
                <label className="form-label">
                  Start Time
                </label>
                <input
                  type="time"
                  className="form-control"
                  placeholder="Enter name..."
                  value={updateCategory?.category_timing[0]?.schedule_time_slots[0]?.start_time}
                  onChange={(e) => handleTimeChange(e, 0, 'start_time')}
                />
                {errors.start_time && <div className="text-danger mt-1">{errors.start_time}</div>}

              </div>
              <div className="col-md-3">
                <label className="form-label">
                  End Time
                </label>
                <input
                  type="time"
                  className="form-control"
                  placeholder="Enter name..."
                  value={updateCategory?.category_timing[0]?.schedule_time_slots[0]?.end_time}
                  onChange={(e) => handleTimeChange(e, 0, 'end_time')}
                />
                {errors.end_time && <div className="text-danger mt-1">{errors.end_time}</div>}

              </div>
            </div>

          </div>
        )}

        {/* List of Saved Schedules */}
        <div className="mt-3">
          <ul>
            {schedules.map((schedule, index) => (
              <li key={index}>{schedule}</li>
            ))}
          </ul>
        </div>
      </div>

      <div className="d-flex flex-container justify-content-end gap-3 mt-5">
        <button type="button" className="btn bt-1" style={{border:"1px solid #53B7E8", color:"#53B7E8"}} onClick={handleCancel}>
          Cancel
        </button>
        <button type="button" className="btn bt-1" style={{backgroundColor:"#53B7E8", color:"#fff"}} onClick={onupdateCategoryData}>
          Save Changes
        </button>
      </div>
    </div>
    </div>
    </div>

  );
}
